// Main theme JavaScript entry point
import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
import focus from "@alpinejs/focus";
import AOS from "aos";
import "aos/dist/aos.css";
import "slick-carousel"; // This imports the Slick JS functionality
import "slick-carousel/slick/slick.css"; // Import the base Slick styles
import "slick-carousel/slick/slick-theme.css"; // Import the default Slick theme
import GLightbox from "glightbox";
import "glightbox/dist/css/glightbox.min.css";
import instantpage from "instant.page";

// jQuery is provided by WordPress - no import needed

// Initialize Alpine.js immediately (needed for DOM interactions)
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.start();

// Global theme object
window.blGlobal = {
  api: `${window.location.origin}/wp-json/api`,
  screen: {
    extraSmall: 375,
    small: 640,
    medium: 768,
    large: 1024,
    extraLarge: 1280,
    extraExtraLarge: 1440,
    active: document.documentElement.clientWidth,
  },
};

// Theme initialization
document.addEventListener("DOMContentLoaded", () => {
  // Initialize Slick Carousel
  $(".slick-slider").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true,
  });

  // Initialize AOS
  AOS.init({
    duration: 800,
    easing: "ease-in-out",
    once: true,
    offset: 0,
  });

  // Initialize GLightbox for galleries only
  // This will only group elements that are inside .bl-popup-gallery containers
  GLightbox({
    selector: ".bl-popup-gallery .bl-popup",
    loop: true,
  });

  // Initialize GLightbox for single items (outside of galleries)
  // This ensures individual .bl-popup elements are treated as single items
  GLightbox({
    selector: ".bl-popup:not(.bl-popup-gallery .bl-popup)",
    loop: false,
  });

  // GF Survey rank — numeric rank badges (1, 2, 3 …) on each choice <li>.
  // Lives in front of the existing drag-handle arrows so users see what
  // position they're assigning. Re-numbers on every sort change via the
  // jQuery UI sortable's bubbled `sortupdate` event.
  const renumberRankChoices = (ul) => {
    if (!ul) return;
    const lis = ul.querySelectorAll(":scope > li.gsurvey-rank-choice");
    lis.forEach((li, idx) => {
      let badge = li.querySelector(":scope > .gsurvey-rank-choice__rank-num");
      if (!badge) {
        badge = document.createElement("span");
        badge.className = "gsurvey-rank-choice__rank-num";
        badge.setAttribute("aria-hidden", "true");
        li.insertBefore(badge, li.firstChild);
      }
      badge.textContent = String(idx + 1);
    });
  };

  document.querySelectorAll("ul.gsurvey-rank").forEach(renumberRankChoices);

  jQuery(document).on("sortupdate sortstop", "ul.gsurvey-rank", function () {
    renumberRankChoices(this);
  });

  // GF Survey rank — "View all prompts" modal
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".gsurvey-rank-choice__view-all");
    if (!btn) return;
    e.preventDefault();

    let prompts = [];
    try {
      prompts = JSON.parse(btn.dataset.prompts || "[]");
    } catch (err) {
      return;
    }
    if (!Array.isArray(prompts) || !prompts.length) return;

    const escape = (s) =>
      String(s)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    const question = escape(btn.dataset.question || "");
    const items = prompts.map((p) => `<li>${escape(p)}</li>`).join("");

    const html = `
      <div class="gf-rank-prompts-modal">
        ${question ? `<h3 class="gf-rank-prompts-modal__title">${question}</h3>` : ""}
        <ul class="gf-rank-prompts-modal__list">${items}</ul>
      </div>
    `;

    const lb = GLightbox({
      elements: [{ content: html, type: "inline" }],
      closeButton: true,
    });
    lb.on("close", () => lb.destroy());
    lb.on("open", () => {
      // Move GLightbox's close button (which lives at the .glightbox-container
      // root and floats in the page corner) into the inline modal so it sits
      // visually inside the white box.
      requestAnimationFrame(() => {
        const modal = document.querySelector(".gf-rank-prompts-modal");
        const closeBtn = document.querySelector(".glightbox-container .gclose");
        if (modal && closeBtn && !modal.contains(closeBtn)) {
          modal.appendChild(closeBtn);
        }
      });
    });
    lb.open();
  });

  // Instant.page is automatically initialized on import
  // It preloads pages on hover for faster navigation
  // No additional configuration needed for basic functionality

  // Initialize theme functionality
  console.log("Bananaland theme initialized");
});

// Initialize theme functionality
console.log("Bananaland theme loaded");
